module.exports = __webpack_public_path__ + "img/40_1.0bfff5cc.png";